module.exports = __webpack_public_path__ + "static/media/leaf.81647a2e.svg";